import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  // Service used for booking item and booking item service item

  angular
    .module('app')
    .service('BookingItemNotificationProviderService', BookingItemNotificationProviderService);

  BookingItemNotificationProviderService.$inject = [
    'RestResource',
    'UtilService',
    '$translate',
    '$filter',
    'UploadService',
  ];

  function BookingItemNotificationProviderService(
    RestResource,
    UtilService,
    $translate,
    $filter,
    UploadService
  ) {
    let utils = new UtilService(this);

    $translate = $filter('translate');

    let apiUrl = environment.apiEndpoint;

    let service = {
      getBookingItemNotificationProvider: getBookingItemNotificationProvider,
      saveBookingItemNotificationProvider: saveBookingItemNotificationProvider,
    };

    return service;

    ////////////////

    function getBookingItemNotificationProvider(
      notificationId,
      subdomain,
      companyApiKey,
      notificationUrl,
      lang
    ) {
      let url = `${apiUrl}/${notificationUrl}/${notificationId}/?sub=${subdomain}&cak=${companyApiKey}&lang=${lang}`;

      return RestResource.request(
        'get',
        url,
        {},
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveBookingItemNotificationProvider(
      notification,
      subdomain,
      companyApiKey,
      params,
      file
    ) {
      let url = `${apiUrl}/${params.notificationUrl}/${notification.id}/?sub=${subdomain}&cak=${companyApiKey}`;

      let msg;

      switch (notification.status) {
        case 'confirmed':
          msg = 'BOOKING_REQUEST_CONFIRMED_MSG';
          break;
        case 'declined':
          msg = 'BOOKING_REQUEST_DECLINED_MSG';
          break;
      }

      return UploadService.uploadFile(
        'put',
        url,
        null,
        params.obj,
        file,
        function () {},
        function () {
          utils._successMsg($translate(msg));
        },
        function (response) {
          utils._errorMsg(response.error);
        }
      );
    }
  }
})();
